import {
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CustomMuiButton } from "../../utils/styleUtils.js";
// import { getInspRuleDetail } from "services/inspectService";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { CloseIcon } from "../../icons/index.tsx";

export const InspRuleModal = ({ ruleData, openModal, setOpenModal }) => {
  const [isCheckedFirst, setIsCheckedFirst] = useState(false);
  const [isCheckedSecond, setIsCheckedSecond] = useState(false);
  const [modelList, setModelList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  // renewal
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [recipeRegex, setRecipeRegex] = useState(null);
  const [imageRegex, setImageRegex] = useState(null);
  const [inspModel, setInspModel] = useState(null);

  useEffect(() => {
    console.log("ruleData", ruleData);
    setRecipeRegex(ruleData.recipe_regex);
    setImageRegex(ruleData.image_regex);
    setInspModel(ruleData.model);
  }, [ruleData]);

  const handleUpdate = async () => {
    navigate(`/insp-rule/${ruleData.id}`);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Dialog
        open={openModal}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            maxWidth: "700px",
            width: "500px",
            p: 2,
          },
        }}
      >
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{ mb: 1, fontWeight: "700", fontSize: 24 }}
              fontFamily={"NotoSansKR-Variable"}
            >
              {t("ViewInspRuleDetails")}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <div className="form-container">
            <div className="input-container">
              <span className="modal-option-title">
                Selected Model
                <br />
              </span>
              <span className="custom-text">
                {inspModel ? inspModel?.name : "-"}
              </span>
            </div>
            <div className="line-with-text">
              <span>Filter</span>
            </div>
            <div className="filter-container">
              <div style={{ marginBottom: "10px" }}>
                <input
                  type="checkbox"
                  id="horns"
                  name="recipe"
                  checked={recipeRegex}
                  disabled
                />
                <span className="modal-option-title">Recipe</span>
                <span className="custom-text">
                  {recipeRegex ? recipeRegex : "-"}
                </span>
              </div>
            </div>
            <div className="filter-container">
              <div style={{ marginBottom: "10px" }}>
                <input
                  type="checkbox"
                  id="horns"
                  name="filename"
                  checked={imageRegex}
                  disabled
                />
                <span className="modal-option-title">FileName</span>
                <span className="custom-text">
                  {imageRegex ? imageRegex : "-"}
                </span>
              </div>
            </div>
          </div>
          <Box
            sx={{
              height: "54px",
              justifyContent: "flex-end",
              gap: "3px",
              position: "sticky",
              bottom: 0,
              backgroundColor: "var(--header-color)",
              zIndex: 999,
              display: "flex",
              width: "100%",
            }}
          >
            <CustomMuiButton
              variant="text"
              onClick={handleClose}
              label={t("Close")}
            />
            <CustomMuiButton
              onClick={handleUpdate}
              variant="contained"
              label={t("Edit")}
            />
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
